import { render, staticRenderFns } from "./userImageModal.vue?vue&type=template&id=56c41e2e&scoped=true&"
import script from "./userImageModal.vue?vue&type=script&lang=js&"
export * from "./userImageModal.vue?vue&type=script&lang=js&"
import style0 from "./userImageModal.vue?vue&type=style&index=0&id=56c41e2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c41e2e",
  null
  
)

export default component.exports